module.exports = __webpack_public_path__ + "img/whatsnew.918e120b.png";